import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../images/IMG_3441.JPG'


const _hoisted_1 = { class: "logement" }
const _hoisted_2 = { class: "logement__content" }
const _hoisted_3 = { class: "logement__inner" }
const _hoisted_4 = { class: "logement__section" }
const _hoisted_5 = { class: "logement__important" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("section", { class: "logement__hero" }, [
      _createElementVNode("div", { class: "logement__hero-overlay" }),
      _createElementVNode("div", { class: "logement__hero-content" }, [
        _createElementVNode("h1", null, "Logement & Taxis")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Logement "),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Logement", -1 /* CACHED */)),
          _cache[2] || (_cache[2] = _createElementVNode("p", null, " Le château ne proposant pas de couchage, nous vous laissons libres de choisir l'hébergement qui vous conviendra le mieux. La région autour du Château du Vivier offre de très nombreuses possibilités : hôtels, chambres d'hôtes, gîtes ou locations, à quelques minutes seulement. ", -1 /* CACHED */)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, " Chacun pourra ainsi trouver le logement qui correspond à ses envies, que ce soit pour une nuit au calme, un week-end entre amis ou un séjour plus confortable. ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["CarTaxiFront"], {
              class: "logement__important-icon",
              size: 28,
              "stroke-width": 1.25
            }),
            _cache[0] || (_cache[0] = _createElementVNode("p", null, [
              _createTextVNode(" Afin de pouvoir bénéficier du service de taxis mis à disposition, les hébergements devront être situés dans un "),
              _createElementVNode("strong", null, "rayon maximum de 20 km"),
              _createTextVNode(" autour du château. ")
            ], -1 /* CACHED */))
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "logement__divider" }, null, -1 /* CACHED */)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "logement__photo" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Elena & Antoine"
          })
        ], -1 /* CACHED */)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "logement__divider" }, null, -1 /* CACHED */)),
        _createCommentVNode(" Taxis "),
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"logement__section\" data-v-c41965a2><h2 data-v-c41965a2>Taxis</h2><p class=\"logement__tagline\" data-v-c41965a2> On s&#39;occupe de tout </p><p data-v-c41965a2>Pour que tout le monde profite sereinement de la soirée :</p><ul class=\"logement__list\" data-v-c41965a2><li data-v-c41965a2>Vous pouvez venir <strong data-v-c41965a2>au château avec votre voiture</strong></li><li data-v-c41965a2>Des <strong data-v-c41965a2>taxis gratuits seront disponibles toute la nuit</strong> pour vous ramener à votre logement (dans un rayon de 20 km)</li><li data-v-c41965a2>Le dimanche matin, les taxis viendront <strong data-v-c41965a2>vous chercher à votre hébergement</strong> pour vous ramener au brunch</li></ul></div>", 1))
      ])
    ])
  ]))
}